import styled from 'styled-components';

const Main = styled.main`
  height: calc(100% - 55px);
  min-height: 480px;
  width: 100%;
  max-width: 100%;
  display: flex;
`;

export default Main;
